import { AssignDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteAssignDiagnosisReport implements AssignDiagnosisReport {
  private readonly url: string;

  private readonly httpClient: HttpClient<AssignDiagnosisReport.Model>;

  constructor(url: string, httClient: HttpClient<AssignDiagnosisReport.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  assign = async (
    params: AssignDiagnosisReport.Params,
  ): Promise<AssignDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{report}', params.id.toString()),
      body: params.body,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
